<template>
    <div>

        <rkm-area
            title="Paciente"
            type="fieldset"
            no-margin-top
            v-if="paciente"
        >

            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}
                                <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                    ({{ paciente.nomeSocial }})
                                </strong>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>

                            <p>
                                <strong>Prontuário:</strong>
                                {{ paciente.prontuario }}
                            </p>

                            <p>
                                <strong>Telefones: </strong>
                                <template v-if="paciente.telefones">
                                    {{ paciente.telefones }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Sexo: </strong>
                                <template v-if="paciente.sexoDescricao">
                                    {{ paciente.sexoDescricao }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CPF: </strong>
                                <template v-if="paciente.cpf">
                                    {{ paciente.cpf | formatCpf }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Data de nascimento: </strong>
                                <template v-if="paciente.dataNascimento">
                                    {{ paciente.dataNascimento | formatDate }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>
                                    Nome da mãe:
                                </strong>
                                <template v-if="paciente.nomeMae">
                                    {{ paciente.nomeMae }}
                                </template>
                                <template v-else>
                                    <i>Desconhecido</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CNS: </strong>
                                <template v-if="paciente.cns">

                                    {{ paciente.cns | formatCns }}
                                </template>

                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Idade: </strong>
                                <template v-if="paciente.idade">
                                    {{ paciente.idade.anos }} anos,
                                    {{ paciente.idade.meses }} meses e
                                    {{ paciente.idade.dias }} dias
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Visitas do Paciente"
            type="fieldset"
            no-margin-top
        >

            <rkm-table
                :fields="fields"
                :items="items"
                sort-by="data"
            >

                <template v-slot:cell(data)="row">
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(dataExportacao)="{ item }">
                    {{ item.dataExportacao }} - {{ item.profissionalExportacao }}
                </template>

                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        @click.stop="search(item)"
                        color="primary"
                        title="Visualizar"
                        small
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Visitas no Domicílio"
            type="fieldset"
            no-margin-top
        >

            <rkm-table
                :fields="fieldsVisita"
                :items="visitas"
                sort-by="data"
            >

                <template v-slot:cell(data)="row">
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(dataExportacao)="{ item }">
                    {{ item.dataExportacao }} - {{ item.profissionalExportacao }}
                </template>

                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        @click.stop="search(item)"
                        color="primary"
                        title="Visualizar"
                        small
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>

import { mapActions } from 'vuex'

// Mixins.
import { repository, error, printExameLaboratorial } from '@/mixins'

// Filters.
import format from '@/filters/formats'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    created() {

        this.repositories = {
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar')
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        fields: [
            {
                key: 'data',
                label: 'Data',
                sortable: true
            },
            {
                key: 'turno',
                label: 'Turno',
                sortable: true
            },
            {
                key: 'imovelTipo',
                label: 'Tipo de imóvel',
                sortable: true
            },
            {
                key: 'profissional',
                label: 'Profissional',
                sortable: true
            },
            {
                key: 'dataExportacao',
                label: 'Exportação',
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        fieldsVisita: [
            {
                key: 'data',
                label: 'Data',
                sortable: true
            },
            {
                key: 'paciente',
                label: 'Paciente',
                sortable: true
            },
            {
                key: 'turno',
                label: 'Turno',
                sortable: true
            },
            {
                key: 'imovelTipo',
                label: 'Tipo de imóvel',
                sortable: true
            },
            {
                key: 'profissional',
                label: 'Profissional',
                sortable: true
            },
            {
                key: 'dataExportacao',
                label: 'Exportação',
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            paciente: null,
        },
        items: [],
        visitas: [],
        paciente: null,
        enums: {
            preferenciaNome
        },
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id) {
                this.setLoading()

                this.repositories.visitaDomiciliar.getAtendimentos({ id : this.id })
                    .then(response => {

                        this.additionals = response.data.additionals
                        this.items = Object.assign(response.data.atendimentos)
                        this.visitas = Object.assign(response.data.visitasDomiciliar)
                        this.paciente = Object.assign(response.data.cidadao)

                        this.loaded = true

                        this.$emit('loaded', {additionals: this.additionals, cidadao: this.paciente})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        search(item) {

            this.$router.push({ name: 'atencao-basica-visita-domiciliar-edit', params: { id: item.id, pacienteId: this.id, visitasRealizadas: this.items }})
        },
        handleCadastrar() {

            let visitasMesmoDia = this.items.concat(this.visitas).filter(visita => visita.data == this.additionals.dataAtual)

            if (visitasMesmoDia.length > 0) {

                let nomes = visitasMesmoDia.map(v => v.paciente)
                let nomesUnicos = [...new Set(nomes)]
                let prefixo = nomes.length > 1 ? 'Os pacientes' : 'O paciente'
                let listaNomes = nomesUnicos.join(', ').replace(/, ([^,]*)$/, ' e $1')

                let msg = `${prefixo} <strong>${listaNomes}</strong>, do mesmo domicílio, já ${
                    nomes.length > 1 ? 'possuem' : 'possui'
                } visitas registradas para <strong>${this.additionals.dataAtual.split('-').reverse().join('/')}</strong>.
                Deseja continuar com o cadastro?`

                this.showWarningConfirmation(
                    'Atenção',
                    `${msg}`,
                    async () => this.$router.push({ name: 'atencao-basica-visita-domiciliar-create', params: { pacienteId: this.id, visitasRealizadas: this.items }}),

                )
            } else {

                this.$router.push({ name: 'atencao-basica-visita-domiciliar-create', params: { pacienteId: this.id, visitasRealizadas: this.items }})

            }
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.visitaDomiciliar.destroy(id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir o atendimento?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error, printExameLaboratorial ],
    props: {
        id: { type: Number, default: null }
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
</style>